export const getCurrentType = type => {
  if (type.includes('age')) {
    return 'age';
  }
  if (type.includes('weight')) {
    return type.includes('target') ? 'target_weight' : 'weight';
  }
  if (type.includes('height')) {
    return 'height';
  }
};

export const measurementAnswers = (answers = {}) => {
  const data = {};
  let height = [];

  Object.values(answers).forEach(({ type, measuring_in, value }) => {
    value = Number(value);

    if (measuring_in === 'ft' || measuring_in === 'inch') {
      height.push(value);
      value = height.join('.');
    }

    if (measuring_in === 'inch') measuring_in = 'ft';

    data[getCurrentType(type)] = { value, measuring_in };
  });

  return data;
};

document.addEventListener('DOMContentLoaded', () => {
  let ageRange;
  const measurementsData = store.getAnswers().measurements;
  const userYearsValueContainer = document.querySelector('#years');
  const userWeightValueContainer = document.querySelector('#u-weight');
  const userWeightUnitContainer = document.querySelector('#u-weight-text');
  const userHeightValueContainer = document.querySelector('#fp-height');
  const userHeightUnitContainer = document.querySelector('#fp-height-text');

  if (store.get('age-range') || backEndVars.ageRange) {
    ageRange = store.get('age-range') || backEndVars.ageRange;
  }

  const data = {
    userAge: ageRange || getAnswersData('age') || measurementAnswers(measurementsData)['age']?.value,
    userWeight:
      getAnswersData('weight')?.value ||
      getAnswersData('weight') ||
      measurementAnswers(measurementsData)['weight']?.value,
    userWeightUnit: getAnswersData('weight_unit') || measurementAnswers(measurementsData)['weight']?.measuring_in,
    userHeight: getAnswersData('height') || measurementAnswers(measurementsData)['height']?.value,
    userHeightUnit: getAnswersData('height_unit') || measurementAnswers(measurementsData)['height']?.measuring_in,
  };

  userYearsValueContainer.textContent = data.userAge;
  userWeightValueContainer.textContent = data.userWeight;
  userWeightUnitContainer.textContent = data.userWeightUnit;
  userHeightValueContainer.textContent = data.userHeight;
  userHeightUnitContainer.textContent = data.userHeightUnit;
});
